import React from 'react';
import NDA from '../onboarding/components/nda';
import { RequiredLayout } from './PostAgreements';

const ResignNDA: React.FC = () => {
    return (
        <RequiredLayout>
            <NDA isResign={true} />
        </RequiredLayout>
    );
};

export default ResignNDA;
